import { Box, IconButton, Skeleton, Typography, styled } from "@mui/material";
import { isMobile } from "react-device-detect";
import theme from "../../styles/styleTheme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NAV from "../../utils/nav.const";

type PropertyDetailsHeaderProps = {
  property: any;
};

const PropertyDetailsHeader = ({ property }: PropertyDetailsHeaderProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <IconButton
        sx={{
          marginTop: "1rem",
          transition: "none",
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          "&:hover": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
          },
        }}
        onClick={() => {
          if (location.key) {
            navigate(-1);
          } else {
            navigate("/" + NAV.PROPERTY_OVERVIEW); // Redirect to a default route if there's no history
          }
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        marginBottom={0.5}
        width={"100%"}
      >
        <Box>
          <PropertyName
            variant="h1"
            sx={{ fontSize: isMobile ? "24px" : "28px" }}
          >
            {property ? (
              property.title
            ) : (
              <Skeleton variant="text" width={300} />
            )}
          </PropertyName>
          <Typography variant="subtitle2">
            {property ? (
              <>
                <Link href={"/zoeken/"}>{t("nav.property_listing")}</Link>
                {" > "}
                {/* {property?.propertyDetails.city} */}
                {property?.title}
              </>
            ) : (
              <Skeleton variant="text" width={250} />
            )}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

const PropertyName = styled(Typography)({
  marginBottom: 5,
  marginTop: 10,
});

const Link = styled("a")({
  textDecoration: "none",
  color: "black",
});

export default PropertyDetailsHeader;
